// リンク編集ポップオーバー: リンク内にキャレットがある時 (collapsed) に出る浮遊メニュー。
// 移動 / 編集 / 解除。テキスト選択中は bubble_menu に任せるため表示しない。

import { $getSelection, $isRangeSelection, $getNodeByKey } from "lexical"
import { $isLinkNode } from "@lexical/link"

export function attachLinkPopover(editor, surface) {
  const bar = document.createElement("div")
  bar.className = "akebono-link-popover"
  bar.style.display = "none"
  bar.innerHTML = `
    <a class="akebono-link-popover-url" target="_blank" rel="noopener"></a>
    <button type="button" data-act="open">移動</button>
    <button type="button" data-act="edit">編集</button>
    <button type="button" data-act="unlink">解除</button>
  `
  document.body.appendChild(bar)

  let currentKey = null
  let currentUrl = ""

  const hide = () => { bar.style.display = "none"; currentKey = null }

  const position = (el) => {
    const r = el.getBoundingClientRect()
    bar.style.top = `${window.scrollY + r.bottom + 6}px`
    bar.style.left = `${window.scrollX + r.left}px`
  }

  const update = () => {
    editor.getEditorState().read(() => {
      const sel = $getSelection()
      if (!$isRangeSelection(sel) || !sel.isCollapsed()) { hide(); return }
      let node = sel.anchor.getNode()
      let link = null
      while (node) { if ($isLinkNode(node)) { link = node; break }; node = node.getParent() }
      if (!link) { hide(); return }

      currentKey = link.getKey()
      currentUrl = (typeof link.getURL === "function" ? link.getURL() : "") || ""
      const el = editor.getElementByKey(currentKey)
      if (!el) { hide(); return }

      const urlEl = bar.querySelector(".akebono-link-popover-url")
      urlEl.textContent = currentUrl
      urlEl.setAttribute("href", currentUrl)
      bar.style.display = "flex"
      position(el)
    })
  }

  bar.addEventListener("mousedown", (e) => {
    const btn = e.target.closest("button")
    if (!btn) return
    e.preventDefault()
    const act = btn.dataset.act
    if (act === "open") {
      if (currentUrl) window.open(currentUrl, "_blank", "noopener")
      return
    }
    if (act === "edit") {
      const next = window.prompt("リンク URL", currentUrl)
      if (next === null) return
      const key = currentKey
      editor.update(() => {
        const node = $getNodeByKey(key)
        if (node && typeof node.setURL === "function") node.setURL(next)
      })
      return
    }
    if (act === "unlink") {
      const key = currentKey
      editor.update(() => {
        const node = $getNodeByKey(key)
        if (!node) return
        node.getChildren().forEach((c) => node.insertBefore(c))
        node.remove()
      })
      hide()
    }
  })

  const unregister = editor.registerUpdateListener(update)
  document.addEventListener("selectionchange", update)
  document.addEventListener("scroll", update, true)

  return () => {
    unregister()
    document.removeEventListener("selectionchange", update)
    document.removeEventListener("scroll", update, true)
    bar.remove()
  }
}
